import {
    type FieldMergeFunction,
    type FieldReadFunction,
    type KeyArgsFunction,
} from "@apollo/client/cache/inmemory/policies";

type Connections = {
    __ref: string;
}[];

interface TypePolicy {
    keyArgs?: KeyArgsFunction;
    read?: FieldReadFunction<Connections, Connections>;
    merge?: FieldMergeFunction<Connections, Connections>;
}

const connectionsTypePolicy: TypePolicy = {
    merge(target = [], source, { variables }) {
        // It is safe to overwrite the cache when we can assume the data is complete:
        // 1. No lensLimit is set
        // 2. The number of lenses in the source is less than the lensLimit
        if (variables?.["lensLimit"] == undefined || source.length < variables["lensLimit"]) {
            return source;
        }
        const sourceSet = new Set(source.map((connectionObj) => connectionObj.__ref));
        const res = [...source, ...target.filter((targetConnection) => !sourceSet.has(targetConnection.__ref))];

        return res;
    },
};

export const groupWithConnectionsTypePolicy = {
    connections: connectionsTypePolicy,
};
